import {
  ApiClientFactory
} from '../ApiClientFactory';
import {
  API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const CalendarClient = {
  /**
   *
   * Returns a calendar with a given id
   */
  getCalendar(groupId) {
    return clientFactory.get(API_URL + 'calendar-events/' + groupId);
  },

  getUserAvailability(userId) {
    return clientFactory.get(
      API_URL + 'calendar-events/availability/' + userId
    );
  },
  bookMentorSlot(userId, availabilityId) {
    return clientFactory.post(
      API_URL + 'calendar-events/availability/reserve?user_id=' + userId + '&availability_id=' + availabilityId
    );
  },
  unbookMentorSlot(userId, availabilityId) {
    return clientFactory.post(
      API_URL + 'calendar-events/availability/unreserve?user_id=' + userId + '&availability_id=' + availabilityId
    );
  }
};